<market-dialog-bottom-up #dialog>
  <div class="modal-box" *ngIf="product() as product">
    <div class="flex justify-between gap-2">
      <img
        [src]="product.image | image"
        [alt]="product.name"
        class="h-48 w-48 rounded-md object-contain" />
      <div class="flex flex-1 flex-col">
        <div class="flex flex-1">
          <div class="flex-1">
            <h3 class="text-lg font-bold">{{ product.name }}</h3>
            <p class="text-lg font-semibold text-slate-600">
              @if (!product.salePrice) {
                <span class="text-error">{{ product.price | vnd }}</span>
              } @else {
                <div class="flex flex-wrap items-center gap-2">
                  <span class="text-lg text-error">
                    {{ product.salePrice | vnd }}
                  </span>
                  <small class="text-sm text-gray-400 line-through">
                    {{ product.price | vnd }}
                  </small>
                </div>
              }
            </p>
            <p>
              Tạm tính: <span class="text-error">{{ totalPrice | vnd }}</span>
            </p>
          </div>
          <div class="flex flex-col items-center">
            <button
              class="btn btn-circle btn-primary btn-sm"
              (click)="updateQuantity(1)"
              [disabled]="loading()">
              +
            </button>
            <input
              class="input block h-[50px] w-[50px] p-0 text-center"
              type="number"
              [ngModel]="quantity()"
              (ngModelChange)="quantityChange($event)"
              min="1" />
            <button
              class="btn btn-circle btn-error btn-sm"
              (click)="updateQuantity(-1)"
              [disabled]="quantity() <= 0 || loading()">
              -
            </button>
          </div>
        </div>
        <div class="flex w-full items-center justify-end">
          <button
            class="btn btn-outline btn-primary btn-xs"
            (click)="cartButtonClickHandler()"
            [disabled]="loading() || quantity() === 0">
            Thêm vào giỏ hàng<market-icon
              iconName="shopping-cart"></market-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
  <form method="dialog" class="modal-backdrop">
    <button [disabled]="loading()">close</button>
  </form>
</market-dialog-bottom-up>
